


































































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Approvisionnement} from '@/models';

import CrudApprovisionnementFilter from '@/components/Crud/Approvisionnement/Filter.vue';
import CrudApprovisionnementEditDialog from '@/components/Crud/Approvisionnement/EditDialog.vue';
import CrudApprovisionnementList from '@/components/Crud/Approvisionnement/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeApprovisionnement, {ApprovisionnementFilter} from '@/stores/modules/approvisionnement';

@Component({
	components: {
		CrudApprovisionnementFilter,
		CrudApprovisionnementEditDialog,
		CrudApprovisionnementList,
		CrudDeleteDialog,
	}
})
export default class ApprovisionnementListView extends Vue {

	@Stored(() => storeApprovisionnement) private approvisionnements!: ResultType<Approvisionnement>;
	@Stored(() => storeApprovisionnement) private filters!: ApprovisionnementFilter;

	private imgPath: string = "";

	private editApprovisionnement: Approvisionnement = null;
	private deletedApprovisionnement: Approvisionnement = null;
	private storeApprovisionnement = storeApprovisionnement;

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editApprovisionnement = new Approvisionnement();
		this.refresh();
	}

	private refresh(): void {
		storeApprovisionnement.dispatch('getC', {filters: true});
	}
}
